import { writable } from "svelte/store";
export const toasts = writable([]);
let nextId = 1;
function push(t) {
    const id = nextId++;
    const toast = Object.assign({ id }, t);
    toasts.update((list) => [...list, toast]);
    if (toast.duration > 0) {
        setTimeout(() => dismiss(id), toast.duration);
    }
    return id;
}
export function dismiss(id) {
    toasts.update((list) => list.filter((t) => t.id !== id));
}
export const toast = {
    info(message, title, duration = 4000) {
        return push({ variant: "info", message, title, duration });
    },
    success(message, title, duration = 4000) {
        return push({ variant: "success", message, title, duration });
    },
    error(message, title, duration = 5000) {
        return push({ variant: "error", message, title, duration });
    },
    warning(message, title, duration = 4500) {
        return push({ variant: "warning", message, title, duration });
    },
    /** Persistent toast that you must dismiss yourself. Returns the id. */
    pending(message, title) {
        return push({ variant: "info", message, title, duration: 0 });
    },
    dismiss,
};
